module.exports = __webpack_public_path__ + "static/media/3.715620f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/works/runescape/images/3.png
// module id = 140
// module chunks = 0